const memberInfoData = []
export default {
  memberInfoData
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/go-out-management/certification-audit/store/state.js